import { render, staticRenderFns } from "./CerrarSesiones.vue?vue&type=template&id=04826e6a"
import script from "./CerrarSesiones.vue?vue&type=script&lang=js"
export * from "./CerrarSesiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports